/*jshint esversion: 6 */
/*jshint strict: false */

import * as d3 from 'd3';

let data = [];

let svg, g, gData, margin, width, height, xScale, xAxis, yScaleScore, yScaleRevenue, yAxisScore, yAxisRevenue, xCount, barWidth;

function setupEvents() {

    window.addEventListener("resize", function() {
        setupGraph();
        updateData();
    });

    d3.selectAll('section.comparison  select').on('change', function () {
        updateData();
    });

}

function setupGraph() {

    svg = d3.select(".comparison .graph svg");

    svg.selectAll("*").remove();

    svg.attr('width', svg.node().getBoundingClientRect().width);
    svg.attr('height', svg.node().getBoundingClientRect().width / 1.8);

    margin = {top: 50, right: 50, bottom: 30, left: 50},
        width = +svg.attr("width") - margin.left - margin.right,
        height = +svg.attr("height") - margin.top - margin.bottom,
        g = svg.append("g").attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    xCount = 11;

    barWidth = (width / xCount) * 0.2;

    xScale = d3.scaleLinear()
        .domain([0, xCount])
        .range([0, width]);

    xAxis = d3.axisBottom(xScale)
        .ticks(xCount);

    yScaleScore = d3.scaleLinear()
        .domain([0, 10])
        .range([height, 0]);

    yScaleRevenue = d3.scaleLinear()
        .domain([0, 200])
        .range([height, 0]);

    yAxisScore = d3.axisLeft()
        .scale(yScaleScore)
        .ticks(5);

    yAxisRevenue = d3.axisLeft()
        .scale(yScaleRevenue)
        .ticks(5);

    g.append('g')
        .attr('transform', 'translate(0,' + height + ')')
        .attr('class', 'axis axis-x')
        .call(xAxis.tickFormat(function (d) {
            return '#' + d
        }))
        .selectAll("text")
        .attr('transform', 'translate(-' + (barWidth * 2) + ',0)');

    g.append('g')
        .attr('class', 'axis axis-y')
        .call(yAxisScore)
        .append("text")
        .attr('x', - (height / 2))
        .attr('y', -30)
        .attr('transform', 'rotate(270)')
        .text("Rating Score");

    g.append('g')
        .attr('transform', 'translate(' + width + ',0)')
        .attr('class', 'axis axis-y')
        .call(yAxisRevenue)
        .append("text")
        .attr('x', - (height / 2))
        .attr('y', 30)
        .attr('transform', 'rotate(270)')
        .text("Box Office Opening Weekend (Million US Dollars)");

    gData = g.append("g")
        .attr('class', 'data');

    for (let i = 1; i <= 2; i++) {

        let filmData = [0, 0, 0, 0, 0, 0, 0, 0];

        let lineScore = d3.line()
            .x(function (d, i) {
                return xScale(i + 0.5);
            })
            .y(function (d) {
                return yScaleScore(0);
            });

        gData.append("path")
            .datum(filmData)
            .attr('class', 'imdb film' + i)
            .attr("d", lineScore);

        gData.append("g")
            .selectAll("circle.imdb")
            .data(filmData)
            .enter()
            .append('circle')
            .attr('class', 'imdb film' + i)
            .attr('r', 0)
            .attr("cx", function (d, i) {
                return xScale(i + 1);
            })
            .attr("cy", height)
            .attr("opacity", 0);


        gData.append("path")
            .datum(filmData)
            .attr('class', 'rotten film' + i)
            .attr("d", lineScore);

        gData.append("g")
            .selectAll("circle.rotten")
            .data(filmData)
            .enter()
            .append('circle')
            .attr('class', 'rotten film' + i)
            .attr('r', 0)
            .attr("cx", function (d, i) {
                return xScale(i + 1);
            })
            .attr("cy", height)
            .attr("opacity", 0);

        gData.append("g")
            .selectAll("rect")
            .data(filmData)
            .enter()
            .append("rect")
            .attr('class', 'film' + i)
            .attr("x", function (d, j) {
                return xScale(j + ( i == 1 ? 0.2 : 0.6 ));
            })
            .attr("y", height)
            .attr("width", barWidth)
            .attr("height", 0);

    }

}

function updateData() {

    let selectedData = [
        data[document.querySelector('section.comparison select:first-of-type').value],
        data[document.querySelector('section.comparison select:last-of-type').value]
    ];

    xCount = selectedData[0].length > selectedData[1].length ? selectedData[0].length : selectedData[1].length;
    barWidth = (width / xCount) * 0.2;
    xScale.domain([0, xCount]);
    xAxis.ticks(xCount);
    g.select('.axis-x')
        .call(xAxis.tickFormat(function (d) {
            return '#' + d
        }))
        .selectAll("text")
        .transition()
        .duration(1000)
        .attr('transform', 'translate(-' + (barWidth * 2) + ',0)');


    for (let i = 1; i <= 2; i++) {

        let filmData = selectedData[i - 1];

        var lineImdb = d3.line()
            .defined(function (d) {
                return d;
            })
            .x(function (d, i) {
                return xScale(i + 0.5);
            })
            .y(function (d) {
                return yScaleScore(d.imdb);
            });

        let lineRotten = d3.line()
            .defined(function (d) {
                return d;
            })
            .x(function (d, i) {
                return xScale(i + 0.5);
            })
            .y(function (d) {
                return yScaleScore(d.rottentomato / 10);
            });

        gData.selectAll('path.imdb.film' + i)
            .datum(filmData)
            .transition()
            .duration(1000)
            .attr("d", lineImdb);

        gData.selectAll('circle.imdb.film' + i)
            .data(filmData)
            .transition()
            .duration(1000)
            .attr('r', 4)
            .attr("cx", function (d, i) {
                return xScale(i + 0.5);
            })
            .attr("cy", function (d) {
                return yScaleScore(d.imdb);
            })
            .attr("opacity", 1);

        gData.selectAll('circle.imdb.film' + i)
            .data(filmData)
            .exit()
            .transition()
            .duration(1000)
            .attr("r", 0)
            .attr("cy", height);


        gData.selectAll('path.rotten.film' + i)
            .datum(filmData)
            .transition()
            .duration(1000)
            .attr("d", lineRotten);

        gData.selectAll('circle.rotten.film' + i)
            .data(filmData)
            .transition()
            .duration(1000)
            .attr('r', 4)
            .attr("cx", function (d, i) {
                return xScale(i + 0.5);
            })
            .attr("cy", function (d) {
                return yScaleScore(d.rottentomato / 10);
            })
            .attr("opacity", 1);

        gData.selectAll('circle.rotten.film' + i)
            .data(filmData)
            .exit()
            .transition()
            .duration(1000)
            .attr("r", 0)
            .attr("cy", height);

        gData.selectAll('rect.film' + i)
            .data(filmData)
            .transition()
            .duration(1000)
            .attr("x", function (d, j) {
                return xScale(j + ( i == 1 ? 0.2 : 0.6 ));
            })
            .attr("y", function (d) {
                return !d ? 0 : yScaleRevenue(d.revenueMillions);
            })
            .attr("width", barWidth)
            .attr("height", function (d) {
                return height - ( !d ? 0 : yScaleRevenue(d.revenueMillions) );
            });

        gData.selectAll('rect.film' + i)
            .data(filmData)
            .exit()
            .transition()
            .duration(1000)
            .attr("y", height)
            .attr("height", 0);
    }


}

function populateDropdown() {

    let select = d3.selectAll('section.comparison select');

    for (let franchise in data) {
        select.append('option')
            .text(franchise)
            .attr('value', franchise)
    }

    d3.select('section.comparison  select:first-of-type option:first-of-type').attr('selected', true);
    d3.select('section.comparison  select:last-of-type option:nth-of-type(2)').attr('selected', true);
}

function loadData(dataDir) {

    d3.csv(dataDir + "films.csv", function (csvData) {
        csvData.forEach(function (d) {
            d.year = +d.year;
            d.imdb = +d.imdb;
            d.rottentomato = +d.rottentomato.replace('%', '');

            d.revenueText = d.revenue;
            d.revenue = d.revenue.replace(/[$,£]+/g, "");
            d.revenueMillions = parseInt(parseInt(d.revenue) / 1000000);

            if (!data.hasOwnProperty(d.franchise)) {
                data[d.franchise] = [];
            }

            data[d.franchise].push(d);
        });
        populateDropdown();
        setupGraph();
        updateData();
    });
}

function init(dataDir) {
    loadData(dataDir);
    setupEvents();
}

export {init}


// WEBPACK FOOTER //
// ./comparison.js